import { Config } from './video-data/config';
import type Luminary from './';

export type ValidationResult = {
    passed: boolean;
    message: string;
};

/**
 * Fixes any duplicate media asset ids by generating new ids.
 */
export const fixUniqueMediaAssetIds = (luminary: Luminary) => {
    luminary.getAssetsByType(Config.MEDIA_ASSET_TYPE).map((asset) => asset.generateNewId());
};

/**
 * Validates that we don't have any duplicate media asset ids. If we do then we can't find them using getAssetById which
 * is a problem.
 */
export const validateUniqueMediaAssetIds = (luminary: Luminary): ValidationResult => {
    const assetIds = luminary.getAssetsByType(Config.MEDIA_ASSET_TYPE).map((asset) => asset.id);
    const uniqueAssetIds = [...new Set(assetIds)];
    if (assetIds.length !== uniqueAssetIds.length) {
        return {
            passed: false,
            message: 'Media asset ids are not unique',
        };
    }
    return {
        passed: true,
        message: 'Media asset ids are unique',
    };
};

export const validateAspectRatioConsistency = (luminary: Luminary): ValidationResult => {
    const aspectRatio = luminary.aspectRatio;

    const scenesWithMismatchedAspectRatio = luminary.scenes.filter(
        (scene) => scene._aspectRatio !== aspectRatio,
    );
    if (scenesWithMismatchedAspectRatio.length > 0) {
        return {
            passed: false,
            message: 'Scene aspect ratios are inconsistent',
        };
    }

    return {
        passed: true,
        message: '',
    };
};
